import React from "react";
import type { Film } from "../../types/film";
export function PosterCard({
  film
}: {
  film: Film;
}) {
  return <article className="group/card relative" tabIndex={0} aria-label={`${film.title}, ${film.tag}`} data-id="element-36" data-mp="3obd24yge9fd5">
      <div className="relative aspect-[2/3] overflow-hidden rounded-[12px] bg-card" data-id="element-37" data-mp="39e48fy3mbzi9">
        <img src={film.image} alt={film.alt} loading="lazy" className="h-full w-full object-cover brightness-[0.6] transition-[transform,filter] duration-[250ms] ease-out group-hover/card:scale-[1.04] group-hover/card:brightness-100 group-focus/card:brightness-100" data-id="element-38" data-mp="3ebci1aapav7w" />
        <div className="absolute inset-0" style={{
        background: "linear-gradient(0deg, rgba(0,0,0,0.9) 0%, rgba(0,0,0,0.3) 40%, rgba(0,0,0,0) 60%)"
      }} aria-hidden="true" data-id="element-39" data-mp="3sb5fdogqg9ou" />
        {film.isNew && <span className="absolute left-0 top-4 bg-signal px-3 py-1 font-mono text-[11px] tracking-[0.12em] text-ink" data-id="element-40" data-mp="ot3sq96lwuem">NEW</span>}
        <div className="absolute inset-x-0 bottom-0 p-4" data-id="element-41" data-mp="207izdxjkajro">
          <h3 className="font-serif text-[22px] leading-[1] tracking-[-0.01em] text-white md:text-[24px]" data-id="element-42" data-mp="205y60b8zh6ve">{film.title}</h3>
          <p className="mt-2 flex flex-wrap gap-x-2 font-mono text-[11px] tracking-[0.08em] text-white/70" data-id="element-43" data-mp="29xlpnpzatjmb">
            <span className="text-white" data-id="element-44" data-mp="256ltimy075kv">{film.tag}</span>
            <span aria-hidden="true" data-id="element-45" data-mp="2552c2t0m2ohi">·</span>
            <span data-id="element-46" data-mp="2iy0mnmlmkn5n">{film.meta}</span>
          </p>
        </div>
      </div>
    </article>;
}